import { ChangeEvent, FocusEvent } from 'react'

export const useInputHandlers = ({
  mintMinAmount,
  mintMaxAmount,
  mintMaxDecimals,
  setValue,
}) => {
  const handleOnBlur = (e: FocusEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value)

    if (!isNaN(value) && value < mintMinAmount) {
      setValue('amount', mintMinAmount, {
        shouldValidate: true,
      })
    }
  }

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const decimalRegex = new RegExp(
      `^(\\d*\\.?\\d{0,${mintMaxDecimals}})$`,
      'g'
    )
    const isValid = value.match(decimalRegex)

    if (isValid) {
      let val = value ? parseFloat(value) : undefined
      if (val && val > mintMaxAmount) {
        val = mintMaxAmount
      }

      setValue('amount', val, { shouldValidate: true })
    }
  }

  return {
    handleOnBlur,
    handleOnChange,
  }
}
